// Helpers to write workouts compactly: amounts and blocks with stable ids.
import type { Amount, Block } from '../types';

/** A time amount in seconds, optionally per side. */
export const t = (seconds: number, perSide = false): Amount => ({ kind: 'time', seconds, perSide });

/** A rep amount, optionally a range (8 to 12) and per side. */
export const reps = (count: number, opts: { max?: number; perSide?: boolean } = {}): Amount => ({
  kind: 'reps',
  reps: count,
  ...(opts.max ? { repsMax: opts.max } : {}),
  ...(opts.perSide ? { perSide: true } : {}),
});

/** Gives each block a stable id from its section: main_1, main_2, ... */
export const ids = (section: string, blocks: Omit<Block, 'id'>[]): Block[] => blocks.map((b, i) => ({ id: `${section}_${i + 1}`, ...b }));
